import React from "react";
import { useTranslation } from "react-i18next";

import AppDialog from "../../design-system/components/AppDialog";
import AppDialogBody from "../../design-system/components/AppDialogBody";
import AppDialogHeader from "../../design-system/components/AppDialogHeader";
import { IconRecurringCalendar } from "../../design-system/icons";
import DemandDepartmentCard from "./DemandDepartmentCard";

const DefaultDemandDialog = ({
  open,
  onClose,
  departments,
  dates,
  defaultValues,
  expandedDepartmentIds,
  onToggleDepartment,
  onUpdateDefaultCell,
}) => {
  const { t } = useTranslation();
  return (
  <AppDialog
    open={open}
    onClose={onClose}
    size="xl"
    className="demand-v2__default-dialog"
  >
    <AppDialogHeader
      title={t("demand_ui.manage_default")}
      subtitle={t("demand_ui.default_help")}
      visual={<IconRecurringCalendar />}
    />
    <AppDialogBody className="demand-v2__default-dialog-body">
      <div className="demand-v2__departments">
        {departments.map((department) => (
          <DemandDepartmentCard
            key={department.id}
            department={department}
            dates={dates}
            mode="default"
            defaultValues={defaultValues}
            expanded={expandedDepartmentIds.has(department.id)}
            onToggle={() => onToggleDepartment(department.id)}
            onUpdateDefaultCell={onUpdateDefaultCell}
          />
        ))}
      </div>
    </AppDialogBody>
  </AppDialog>
  );
};

export default DefaultDemandDialog;
